export default "__VITE_ASSET___FuVHcsx__"